import { render } from "./ToastAlert.vue?vue&type=template&id=252cf9d1&scoped=true"
import script from "./ToastAlert.vue?vue&type=script&lang=js"
export * from "./ToastAlert.vue?vue&type=script&lang=js"

import "./ToastAlert.vue?vue&type=style&index=0&id=252cf9d1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252cf9d1"]])

export default __exports__